"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import DistributionDialog from "../../../../components/dialog/DistributionDialog.vue";
import _ from "lodash";
import API from "@ym-framework/api-utils";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
const gridController = new GridController(
  new APIDataSource("api://base.auth.pro/v1/virtual-desktops")
);
let AccountBindVD = class extends Vue {
  constructor() {
    super(...arguments);
    this.gridController = gridController;
    this.selectLock = false;
    this.selectDatas = [];
    this.searchStr = "";
    this.selectedGroup = "";
    this.distribution_group = ["DISTRIBUTED", "UNDISTRIBUTED"];
    this.user_datas = [];
    this.distrib = true;
    this.undistrib = true;
    this.groupList = [];
    this.isSelected = false;
    this.showSelect = false;
    this.user_guid = "";
    this.handleDistributionChange = _.debounce((flag) => __async(this, null, function* () {
      this.isSelected = flag;
      this.gridController.query.current = 1;
      this.updateQueryParams();
      yield this.gridController.search();
    }), 300);
    this.searchByName = _.debounce((searchStr) => {
      this.searchStr = searchStr != null ? searchStr : "";
      this.gridController.query.current = 1;
      this.updateQueryParams();
      this.gridController.search();
    }, 500);
  }
  created() {
    this.gridController.on("searched", (item) => __async(this, null, function* () {
      this.checkItem();
    }));
    this.gridController.size = true;
    this.gridController.pagePosition = "dialog";
  }
  open(datas) {
    return __async(this, null, function* () {
      try {
        this.user_datas = datas;
        this.gridController.pagePosition = "dialog";
        this.searchStr = "";
        this.selectDatas = [];
        this.selectLock = false;
        this.groupList = [];
        yield this.getGroupList();
        this.gridController.query.current = 1;
        this.updateQueryParams();
        this._distribution_main.open();
        this._distribution_main.setBtn(false);
        this._distribution_main.setOptSpan(18, 6);
        yield this.gridController.search();
        this.$nextTick(() => __async(this, null, function* () {
          if (datas.length === 1) {
            this.user_guid = datas[0].guid;
            this.showSelect = true;
            const result = yield API.get(
              `api://base.auth.pro/v1/users/${datas[0].guid}/virtual-desktops`
            );
            for (let item of result.data.datas) {
              this._distribution_main.add({
                id: item.oldVdId,
                label: item.name
              });
            }
            this.checkItem();
          }
        }));
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getGroupList() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(
          "api://base.auth.pro/v1/groups",
          {
            params: {
              type: "VD"
            }
          }
        );
        this.groupList = response.data.datas || [];
        const recycleGroup = _.find(this.groupList, {
          id: "vdgroup_system_recycle"
        });
        if (recycleGroup) {
          this.groupList = _.reject(this.groupList, {
            id: "vdgroup_system_recycle"
          });
        }
        if (this.groupList.length > 0) {
          const defaultGroup = this.groupList.find((item) => item.id === this.selectedGroup) || this.groupList[0];
          this.selectedGroup = defaultGroup.id;
        } else {
          this.selectedGroup = "";
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  changed(data) {
    this.selectLock = true;
    let rows = _.differenceWith(
      this.selectDatas,
      data,
      (selectData, data2) => selectData.vdOldId == data2.id
    );
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, false);
      }
    }
    this.selectLock = false;
  }
  selectItems(items) {
    this.selectDatas = [];
    this.selectDatas = items;
    if (!this.selectLock) {
      this._distribution_main.syncData(
        this.gridController.result.datas,
        items,
        "vdOldId",
        "name"
      );
    }
  }
  checkItem() {
    if (this._distribution_main === void 0) {
      return;
    }
    let selectDatas = this._distribution_main.getAll();
    let rows = _.intersectionWith(
      this.gridController.result.datas,
      selectDatas,
      (selectData, data) => selectData.vdOldId == data.id
    );
    this.selectLock = true;
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, true);
      }
    }
    this.selectLock = false;
  }
  saved(data) {
    return __async(this, null, function* () {
      let _ids = _.map(data, "id");
      let user_ids = _.map(this.user_datas, "guid");
      try {
        if (user_ids.length === 1) {
          yield API.post(`api://base.auth.pro/v1/virtual-desktop-admins`, {
            vdIds: _ids,
            userIds: user_ids,
            isCoverage: true,
            mode: "REPLACE",
            type: "USER"
          });
        }
        if (user_ids.length > 1) {
          yield API.post(`api://base.auth.pro/v1/virtual-desktop-admins`, {
            vdIds: _ids,
            userIds: user_ids,
            isCoverage: false,
            mode: "APPEND",
            type: "USER"
          });
        }
        this.$message.success(
          this.$t("team_management.vd_admin.dialog.success_message")
        );
        this._distribution_main.close();
        this.$emit("success");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  changeGroup(groupId) {
    return __async(this, null, function* () {
      this.selectedGroup = groupId;
      this.gridController.query.current = 1;
      this.updateQueryParams();
      yield this.gridController.search();
    });
  }
  updateQueryParams() {
    const conditions = [];
    if (this.selectedGroup) {
      conditions.push(`group=="${this.selectedGroup}"`);
    }
    if (this.distribution_group.length === 1) {
      conditions.push(`distribution==${this.distribution_group[0]}`);
    }
    if (this.searchStr) {
      conditions.push(`name=like='${this.searchStr}'`);
    }
    if (this.isSelected) {
      conditions.push(`bindType==NOT_BOUND`);
      conditions.push(`bindUser==${this.user_guid}`);
    }
    this.gridController.query.params = {
      type: "BRIEF",
      search: conditions.join(";")
    };
  }
};
__decorateClass([
  Ref("distribution-dialog")
], AccountBindVD.prototype, "_distribution_main", 2);
__decorateClass([
  Ref("multipleTable")
], AccountBindVD.prototype, "_multipleTable", 2);
AccountBindVD = __decorateClass([
  Component({
    components: {
      UiGrid,
      DistributionDialog
    }
  })
], AccountBindVD);
export {
  AccountBindVD as default
};
